<template>
  <span class="radar-grid-object-list-tab">
    <button
      class="radar-grid-object-list-tab-button aisea-text-14-400-white"
      :class="{
        danger: isObjectDanger,
        caution: isObjectCaution,
        safe: isObjectSafe,
        selected: isSelected,
      }"
      @click.stop.prevent="handleClick"
    >
      <div class="truncate flex justify-around items-center gap-2 aisea-p-2">
        <span class="radar-grid-object-risk-level flex-shrink-0">{{
          riskLevelLabelJa
        }}</span>
        <span class="radar-grid-object-count flex-shrink-0 truncate ml-auto">{{
          objectCount
        }}</span>
      </div>
    </button>
  </span>
</template>

<script>
import { RadarGridMixin } from "@/mixins";

export default {
  name: "RgObjectListTab",
  mixins: [RadarGridMixin],
  props: {
    riskLevel: { type: Number, required: false }, // SAFE: 0, CAUTION: 5, DANGER: 10 のみ想定
    selectedRiskLevel: { type: Number, require: false },
    handleClick: {
      type: Function,
      required: true,
    },
    radarGridObjectFirestoreData: {
      type: Object, // Object<RadarGridObject.id, RadarGridObject>
      required: true,
    },
    rgRiskLevelManagerMap: {
      type: Object, // Object<RadarGridObject.id, RgRiskLevelManager>
      required: true,
    },
  },
  computed: {
    radarGridObjectRiskLevelSetting() {
      return this.RADAR_GRID_OBJECT_RISK_LEVEL[this.parsedRiskLevel];
    },
    parsedRiskLevel() {
      return this.parseRiskLevelByThreshold(this.riskLevel);
    },
    isObjectCaution() {
      return this.isCaution(this.riskLevel);
    },

    isObjectDanger() {
      return this.isDanger(this.riskLevel);
    },

    isObjectSafe() {
      return this.isSafe(this.riskLevel);
    },
    riskLevelLabelJa() {
      return this.radarGridObjectRiskLevelSetting.labelJa;
    },
    objectCount() {
      if (!this.radarGridObjectFirestoreData) return 0;
      return Object.values(this.radarGridObjectFirestoreData)
        .filter((radarObject) => radarObject)
        .filter(({ id }) => this.rgRiskLevelManagerMap[id])
        .map((radarObject) => ({
          ...radarObject,
          rgRiskLevelManager: this.rgRiskLevelManagerMap[radarObject.id],
        }))
        .filter(
          ({ rgRiskLevelManager }) =>
            rgRiskLevelManager.riskLevel === this.riskLevel,
        ).length;
    },
    isSelected() {
      return this.selectedRiskLevel === this.parsedRiskLevel;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.radar-grid-object-list-tab {
  --danger-color: #602828;
  --danger-hover-color: #ae3030;
  --caution-color: #4b4b1c;
  --caution-hover-color: #aeb119;
  --safe-color: #19462d;
  --safe-hover-color: #168545;

  button {
    // reset button style
    all: unset;
    outline: revert;
  }
  .radar-grid-object-list-tab-button {
    width: 80px;
    height: 36px;
    cursor: pointer;
    border-radius: 5px;
    text-align: center;

    .radar-grid-object-count {
      max-width: 40px;
    }

    background-color: var(--danger-color);
    &:hover,
    &.selected {
      background-color: var(--danger-hover-color);
    }

    &.danger {
      background-color: var(--danger-color);
      &:hover,
      &.selected {
        background-color: var(--danger-hover-color);
      }
    }
    &.caution {
      background-color: var(--caution-color);
      &:hover,
      &.selected {
        background-color: var(--caution-hover-color);
      }
    }
    &.safe {
      background-color: var(--safe-color);
      &:hover,
      &.selected {
        background-color: var(--safe-hover-color);
      }
    }
  }
}
</style>
